const EXPLICIT_TOKEN_ERROR_PATTERNS = [
  'invalid or expired token',
  'invalid token',
  'expired token',
  'refresh token',
  'bearer token',
  'missing sub',
  'jwt malformed',
  'jwt expired',
  'invalid signature',
];

export const isTokenInvalidError = (data: any, url?: string): boolean => {
  if (!data) {
    return false;
  }

  const targetUrl = String(url || '').toLowerCase();
  if (targetUrl.includes('/auth/login')) {
    return false;
  }

  const message = String(data.error || data.code || data.message || '').toLowerCase();
  const hasTokenKeyword =
    message.includes('token') ||
    message.includes('refresh') ||
    message.includes('bearer') ||
    message.includes('jwt');

  return (
    EXPLICIT_TOKEN_ERROR_PATTERNS.some((pattern) => message.includes(pattern)) ||
    (hasTokenKeyword && message.includes('invalid')) ||
    (hasTokenKeyword && message.includes('expired'))
  );
};

export const isSessionInvalidError = (data: any, status?: number, url?: string): boolean => {
  const tokenInvalid = isTokenInvalidError(data, url)

  if (!tokenInvalid) {
    const normalized = String(data?.error || data?.code || data?.message || '').toLowerCase()
    const hasSessionKeyword =
      normalized.includes('session') ||
      normalized.includes('logged out') ||
      normalized.includes('login again') ||
      normalized.includes('please login')
    return (status === 401 || status === 403) && hasSessionKeyword
  }

  return status === 401 || status === 403
}
